import React, { Component } from "react"
import { IntlProvider, addLocaleData, FormattedMessage } from "react-intl"
import en from "react-intl/locale-data/en"
import enMessages from "../../locales/en.js"
import Img from 'gatsby-image'
import it from "react-intl/locale-data/it"
import itMessages from "../../locales/it.js"
import Link from 'gatsby-link'

import Nav from '../Nav'

addLocaleData([...it, ...en])

const messages = {
  it: itMessages,
  en: enMessages
}

const locales = ["en", "it"]

class Button extends Component {
  render() {

    let locale = this.props.locale
    let airbnb = this.props.airbnb
    let logo = this.props.logo

    return(
      <div className="wrap--mini">
        <div className="house-button">
          <div
            className="house-button__image">
            <Img
              sizes={ logo.sizes }
            />
          </div>
          <a
            href={ airbnb }
            className="house-button__link"
          >
            <IntlProvider
              locale={ locale }
              messages={ messages[locale] }
            >
              <div className="house-button__title">
                <FormattedMessage id={"book"} />
              </div>
            </IntlProvider>
          </a>
        </div>
      </div>
    )
  }
}

export default Button



// WEBPACK FOOTER //
// ./src/components/Button/index.js